import { Box } from '@mui/material';
import { Avatar } from '@portals/core/src/components/Avatar/Avatar';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { theme } from '@portals/core/src/themes/immobilien/main';
import React from 'react';

import { getStyles } from '../../EstateContact.styles';

interface BrokerInfoSectionProps {
  broker: {
    firstName?: string;
    lastName?: string;
    fullSalutation?: string;
    imageUrl?: string;
  };
  instituteName?: string;
}

export const BrokerInfoSection = ({ broker, instituteName }: BrokerInfoSectionProps): React.ReactElement => {
  const styles = getStyles(theme);

  const { firstName, lastName, fullSalutation, imageUrl } = broker;

  return (
    <Box sx={styles.avatarContainer}>
      <Avatar sx={styles.avatar} alt={fullSalutation} src={imageUrl} />
      <Box sx={styles.avatarInfo}>
        <Typography className="estate-contact-form-broker" variant="h5">
          {firstName} {lastName}
        </Typography>
        {instituteName && <Typography variant="body2">{instituteName}</Typography>}
      </Box>
    </Box>
  );
};

BrokerInfoSection.displayName = 'BrokerInfoSection';
